import React, { Component } from 'react';
import CanvasElement, { CanvasElementPropTypes } from '../../../canvas-element';
import pick from 'lodash/pick';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import SelectedElementWrapperUtil from '../utils';
import { observer } from 'mobx-react';
import { GroupUIEdge } from '../../../element-types/group-element/constant';
import { transformOfFlip } from '../../../common';
import ObserverFactory from '@src/slide/application/service/modelObserver/observerFactory';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { GroupRefreshMenu } from '@src/slide/domain/ui-model/element-modeles/property/menu-property/refresh/group';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import type { SelectElementWrapper } from '@src/framework/editor/src/page/index/components/canvas/edit-panel/selected-element-layer/selected-ele-wrapper-factory';

interface SelectedGroupWrapperProps extends SelectElementWrapper {
    element: IGroupModel;
    scale: number;
    selectedElementInGroupInMobile: boolean;
}

@observer
class SelectedGroupWrapper extends Component<SelectedGroupWrapperProps> {
    public constructor(props) {
        super(props);
    }

    public componentDidMount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.addLocalChangeObserver(this.updateComponent);
            observer.addChangesetObserver(this.updateComponent);
        }
        const elementModel = this.props.element;
        if (elementModel.isRootGroup) {
            // 选中组合元素后需要刷新组合元素item
            GroupRefreshMenu.caculateItemValues(elementModel);
        }
    }

    public updateComponent = () => {
        this.forceUpdate();
    };

    public componentWillUnmount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.removeLocalChangeObserver(this.updateComponent);
            observer.removeChangesetObserver(this.updateComponent);
        }
    }

    public render() {
        const elementModel = this.props.element;
        const frameInfo = SelectedElementWrapperUtil.frameInfoForInner(elementModel);
        const frameWithOp = elementModel.getFrame?.().getFrameInfo(true);
        const relativeInfo = SelectedElementWrapperUtil.relativeInfoForInner(elementModel);
        const { isRootGroup } = elementModel;
        const hasChart = (getAllChildModels(elementModel, true) || []).some(i => i.type === UIModelType.CHART);
        let rootGroupFrame: Partial<IRect> = {};
        if (isRootGroup) {
            const rect = elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame);
            rootGroupFrame = {
                left: rect.left - GroupUIEdge,
                top: rect.top - GroupUIEdge,
                width: rect.width + (GroupUIEdge * 2),
                height: rect.height + (GroupUIEdge * 2),
            };
        }
        return (
            <CanvasElement
                {...pick(this.props, Object.keys(CanvasElementPropTypes))}
                showSelectBorder={true}
                scale={this.props.scale}
                rect={{
                    left: rootGroupFrame.left || 0,
                    top: rootGroupFrame.top || 0,
                    width: rootGroupFrame.width || 0,
                    height: rootGroupFrame.height || 0,
                }}
                editable={true}
                resizeHorizontal={true}
                resizeVertical={true}
                canRotate={!hasChart}
                relativeRotate={relativeInfo.relativeRotate}
                relativeFlipH={relativeInfo.relativeFlipH}
                relativeFlipV={relativeInfo.relativeFlipV}
                rotate={frameInfo.rotate}
                onBorderClick={this.props.onBorderClick}
                {
                    ...SelectedElementWrapperUtil
                        .commonPropsForCanvasElement(elementModel, this.props.scale)
                }
                style={{
                    transform: transformOfFlip(frameWithOp),
                    width: isRootGroup ? rootGroupFrame.width : frameWithOp.width,
                    height: isRootGroup ? rootGroupFrame.height : frameWithOp.height,
                    position: 'absolute',
                }}
                onBorderMouseDown={this.handleBorderMouseDown}
                selectedElementInGroupInMobile={this.props.selectedElementInGroupInMobile}
                isMobileRotatingMode={this.getRotateElementHandler()?.isMobileRotatingMode ?? false}
            >
            </CanvasElement>
        );
    }

    private handleBorderMouseDown = () => {
        this.getSelectionService()?.selectedElements.clear(SelectedEleMgrType.GROUP);
    };

    private getSelectionService() {
        return (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .viewableServiceLayer?.selectionService;
    }

    private getRotateElementHandler() {
        return (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .editableServiceLayer?.rotateElementHandler;
    }
}

export default SelectedGroupWrapper;
